import UIComponent from "../component";

export const ToastManager = new (class ToastManager {
    constructor() {
        this.toasts = [];
    }

    addToast(toast) {}
})();

export class Toast extends UIComponent {
    init() {
        this.messages = this.dataJson("messages");
        
        this.timeId;
    }

    show(text, autoHide = true, folder) {
        if (this.timeId) clearTimeout(this.timeId);

        this.text = this.messages[text] || text;

        if (folder) {
            this.folder_name.element.textContent = `"${folder}"`;
        } else {
            this.folder_name.element.textContent = "";
        }

        this.addClass("show");

        if (autoHide) {
            this.timeId = setTimeout(() => {
                this.hide();
                this.folder_name.element.textContent = ""
            }, 2000);
        }
    }

    hide() {
        this.removeClass("show");
        this.emit('toastHidded');
    }

    onHidded(cb) {
        this.on('toastHidded', cb);
    }
}
